/**
 * querySync.ts — bridges WebSocket broadcasts to TanStack Query cache invalidation.
 *
 * Channels that don't have dedicated Zustand stores (orders, curves, dividends,
 * coupons) use TanStack Query for server state. When a WS broadcast arrives for
 * those channels we invalidate the relevant query keys so any mounted hooks
 * automatically refetch.
 */

import { QueryClient } from "@tanstack/react-query";

let _queryClient: QueryClient | null = null;

export function registerQueryClient(qc: QueryClient) {
  _queryClient = qc;
}

export function invalidateWsQueries(queryKey: string[]) {
  if (_queryClient) {
    void _queryClient.invalidateQueries({ queryKey });
  }
}
